export default __webpack_public_path__ + "static/media/fast-shipping-badge.1c010287.png";